import React from 'react';
import { FiFacebook, FiTwitter, FiInstagram } from 'react-icons/fi'
import { FooterOverlay, Newsletter } from '../../components'
import { images } from '../../constants';



const Footer = () => {

  const year = new Date().getFullYear();

    return (
    <div className='app__footer' id='footer' >
      <FooterOverlay />
      <Newsletter />
      <div className="app__footer-links">
        <div className="app__footer-links_contact">
          <h1 className="app__footer-headtext">Contact Us</h1>
          <p className="p__opensans">4, Oyemuwa Street, NAF Valley, Asokoro, Abuja, Nigeria.</p>
          <p className="p__opensans">+2348063990938</p>
          <p className="p__opensans">+2348152010310</p>
        </div>
        <div className="app__footer-links_logo">
          <img src={images.foodiverse} alt="footer_logo" />
          <p className="p__opensans">&quot;The best way to find yourself is to lose yourself in the service of others.&quot;</p>
          <img src={images.spoon} className="spoon__img" alt='spoon' />
          <div className="app__footer-links_icons">
            <FiFacebook />
            <FiTwitter />
            <FiInstagram />
          </div>
        </div>
        <div className="app__footer-links_work">
          <h1 className="app__footer-headtext">Working Hours</h1>
          <p className="p__opensans">Monday-Friday:</p>
          <p className="p__opensans">08:00 am - 3:00 am</p>
          <p className="p__opensans">Saturday-Sunday:</p>
          <p className="p__opensans">07:00 am - 4:00 am</p>
        </div>
        <div className='app__scroll' >
          <div className='scroll__vertical-line' />
          <a href='#navbar' ><p className='p__cormorant' >Top</p></a>
        </div>
      </div>
      <div className="footer__copyright">
        <p className="p__opensans">Copyright ⓒ {year} Foodiverse. All Rights reserved.</p>
      </div>
    </div>

  );
} 
export default Footer;
